module.exports = __webpack_public_path__ + "static/media/tissue_paper_1.56590c78.png";